// src/utils/qbFreshFields.js — qbfresh-3d6a8f15 (BACKLOG row 31)
// The invoice page is handed its invoice once, as a prop, and never hears about later changes. So
// after "Export to QB" the page kept showing what it was opened with: a red "push failed" banner
// from an EARLIER failed export stayed up even though this export had succeeded.
//
// After an export or a "Check again" the page now re-reads the invoice and lays the QuickBooks
// sync fields — and only those — over the invoice it was given. A field the stored invoice no
// longer has (a cleared error) is REMOVED from the copy, never set to undefined, so the copy is
// still a valid record if it is handed to the edit form.

const QB_SYNC_FIELDS = [
    'qbInvoiceId', 'qbInvoiceNumber', 'lastSyncedAt',
    'qbPushError', 'qbPushErrorAt',
    'qbAutoSyncDeferred', 'qbAutoSyncDeferredReason', 'qbAutoSyncDeferredAt',
    'qbTotalMismatch',
    'qbTaxCodeHold', // taxexempt3-8c4f2a1d — held: QuickBooks has no code for what was charged
];

/** The QuickBooks sync fields present on a stored invoice (absent ones are left out). */
function pickQbFields(stored) {
    const out = {};
    if (!stored || typeof stored !== 'object') return out;
    for (const k of QB_SYNC_FIELDS) if (stored[k] !== undefined && stored[k] !== null) out[k] = stored[k];
    return out;
}

/**
 * invoice: what the page was given. fresh: { id, fields } from the last re-read, or null.
 * → the same invoice object when there is nothing fresh for it; else a copy with the QuickBooks
 * sync fields replaced by the fresh ones.
 */
function withFreshQb(invoice, fresh) {
    if (!invoice || !fresh || !fresh.id || fresh.id !== invoice.id || !fresh.fields) return invoice;
    const copy = { ...invoice };
    for (const k of QB_SYNC_FIELDS) { if (k in fresh.fields) copy[k] = fresh.fields[k]; else delete copy[k]; }
    return copy;
}

export { QB_SYNC_FIELDS, pickQbFields, withFreshQb };
